import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";

export const getEngagementsApi = function* getEngagements(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

export const getEventDetails = function* getEventInfo(action) {
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.EVENTS + `${action.id}/`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};
